.bx{flex-shrink:0;}